export const actionType = `@Selfcare/FLUSH`;

export default () => ({ type: actionType });
